import './index.css';
import styled, { createGlobalStyle } from "styled-components";
import { IMG_MODAL_BG, IMG_NOTICE, IMG_SUCCESS } from "@assets";

const GlobalStyles = createGlobalStyle`
* {
  margin: 0;
  font-family: 'Archivo', 'Yati';
}

body {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000000;
}

#root {
  width: 100vw;
  overflow-x: hidden;
  max-width: 480px;
  height: 100vh;
  background: ${(props) => props.theme.backgroundColor};   
}

.ant-input-affix-wrapper:not(.ant-input-status-error) {
  border-radius: 15px !important;
  border: 1px solid #999 !important;
  background: #FFF !important;

  color: #1C1C1C !important;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */

}

input::placeholder {
  color: #979797 !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */
}

.ant-input-affix-wrapper:hover, .ant-input:hover {
  /* border: 1.5px solid  #EE3530 !important; */
  /* border: none !important; */
}

.ant-spin-dot i {
  background-color: ${(props) => props.theme.primaryColor} !important;
}

.ant-modal:not(.custom-calendar-modal):not(.lang-modal):not(.pocket-money-modal) {
    
  .ant-modal-content {
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 100px 16px 16px 16px;
    border-radius: 20px;
    background: #FFF;
    box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.10);
  }

  .ant-modal-body {
    padding: 0px 6px;
    color: #616161 !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: 1.5 !important;
  }

  .ant-modal-header {
    background: transparent !important;
    margin: 0;
  }

  .ant-modal-title {
    background-color: transparent !important;
    font-style: normal !important;
    font-weight: 700 !important;
    line-height: normal !important;
    color: #E39401 !important;
    text-align: center;
  }

  .ant-modal-footer {
    margin: 0;
    display: flex;
    justify-content: center;
    gap: 10px;

    .ant-btn {
      flex: 1;
      padding: 0 !important;
      margin: 0 !important;
      height: 50px !important;
    }
  }

  #modal-icon {
    width: 70px;
    position: absolute;
    top: 9px;
    left: 50%;
    transform: translate(-50%,0);
  }
}

.ant-btn-primary:not(.ant-btn-dangerous) {
  background: ${(props) => props.theme.buttonColor};
  border-radius: 15px;
  border: 2px solid #FFCB2F !important;
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.10), 0px 7px 10px 0px rgba(255, 255, 255, 0.25);

  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5;
  color: #fff !important;

  :hover {
    background: ${(props) => props.theme.buttonHoverColor};
    border: 2px solid #FFCB2F !important;
    color: #FFF;
  }

  :disabled {
    color: #DAD6D6 !important;
    background: ${(props) => props.theme.buttonColor};
    border-radius: 15px;
    box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.10), 0px 7px 10px 0px rgba(255, 255, 255, 0.25);
    border:  none !important;
    cursor: not-allowed;

    :hover {
      background: ${(props) => props.theme.buttonColor};
    }
  }
}

.ant-btn-primary:not(:disabled):not(.ant-btn-disabled):hover{
  background: ${(props) => props.theme.buttonHoverColor};
}

.ant-btn-default {
  background: linear-gradient(180deg, #FEFBF1 0%, #FDF995 100%) !important;
  border: 2px solid #F8D768 !important;
  border-radius: 15px;
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.10), 0px 7px 10px 0px rgba(255, 255, 255, 0.25);

  color: #E39401 !important;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 162.5% */

  :hover {
    background: linear-gradient(180deg, #FEFBF1 0%, #FDF995 100%) !important;
    color: #E39401 !important;
    border: 2px solid #F8D768 !important;
  }
}

.ant-btn-secondary{
  border-radius: 15px;
  border: 2px solid #CC0D0E;
  background: linear-gradient(180deg, #F00F11 0%, #CC0D0E 36%);
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.10), 0px 7px 10px 0px rgba(255, 255, 255, 0.25);

  color: #fff;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 162.5% */
}

.ant-table-wrapper {
  
  tr:nth-child(2n) {
    td {
      background-color: #E1CCE0;
    }

    :hover {
      td {
        background-color: #E1CCE0 !important;
      }
    }
  }

  tr {
      >td {
        background-color: ${(props) => props.theme.backgroundColor};

        font-size: 14px;
        font-weight: normal;
        color: #000000;

        :first-child, :last-child {
          padding: 8px 24px !important;
        }
    }

    :hover {
      >td {
        background-color: ${(props) => props.theme.backgroundColor} !important;
      }
    }
  }

  tr>th {
    background-color: #71207C !important;
    font-size: 14px !important;
    font-weight: normal !important;
    color: #FFFFFF !important;

    ::before {
      display: none;
    }

    :first-child {
      border-start-start-radius: 5px !important;
      border-end-start-radius: 5px !important;
      padding: 8px 24px !important;
    }

    :last-child {
      border-start-end-radius: 5px !important;
      border-end-end-radius: 5px !important;
      padding: 8px 24px !important;
    }
  }
}

.ant-radio-wrapper .ant-radio-checked {
    
  ::after {
    border: 1px solid ${(props) => props.theme.primaryColor};
  }

  .ant-radio-inner {
    border-color: ${(props) => props.theme.primaryColor};
    background-color: ${(props) => props.theme.primaryColor};
  }
}

.ant-picker-calendar {
    .ant-radio-group {
        display: none !important;
    }
}

.ant-notification-notice {
  padding: 12px !important;
}

.ant-notification-notice-close {
  top: 12px !important;
}

.ant-notification-notice-description {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* Hide scrollbar for Chrome, Safari and Opera */
::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
-ms-overflow-style: none;  /* IE and Edge */
scrollbar-width: none;  /* Firefox */

.otp-length-8 {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  gap: 5px;

  @media screen and (max-width: 290px) {
    flex-wrap: wrap;
  }
}

.otp-length-6 {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 2px;

  @media screen and (max-width: 290px) {
    flex-wrap: wrap;
    justify-content: center;
  }
}

.custom-calendar-modal {

  .ant-modal-footer {
      text-align: center;
  }

  @media screen and (max-width: 325px) {
    .ant-modal-content {
      padding: 20px 0 !important;
    }
  }
  
}

.trx-history-dropdown {
  background-color: #EFEFEF;

  .ant-select-item-option {
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    color: #101415;
  }
}

.ant-drawer-content-wrapper {
    height: auto !important;
}

.ant-form-item-explain-error {
  font-size: 12px;
}

.ant-result {
  padding: 16px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .ant-result-icon {
    margin-bottom: 8px !important;
  }
  
  .ant-result-title {
    color: #979797;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 30px; /* 150% */
  }

  .ant-result-subtitle {
    color: #979797;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px; /* 162.5% */
  }

  .ant-result-extra{
    width: 100%;

    .ant-btn-primary {
    min-width: 170px;
    height: 52px;
    width: 100% !important;

    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5;
    color: #ffffff !important;
  }
  }


}

input {
    font-family: Archivo !important;
    font-size: 16px;
    font-weight: 400;

    ::placeholder {
      font-family: Archivo !important;
      color: #9B92BB !important;
    }
}

.ant-input:focus::placeholder {
    color: transparent !important;
  }

.grecaptcha-badge { visibility: hidden; }
`;

export const ModalTopBg = styled.img.attrs({
  alt: 'modalbg',
  src: IMG_MODAL_BG,
})`
position: absolute;
top: 0;
left: 0;
width: 100%;
border-radius: 20px 20px 0 0;
`;

export const NoticeFilled = styled.img.attrs({
  alt: 'modalbg',
  src: IMG_NOTICE,
})`
width: 85px;
position: absolute;
top: 10px;
left: 50%;
transform: translate(-50%,0);
`;

export const SuccessFilled = styled.img.attrs({
  alt: 'modalbg',
  src: IMG_SUCCESS,
})`
width: 85px;
position: absolute;
top: 10px;
left: 50%;
transform: translate(-50%,0);
`;

export default GlobalStyles;
